/* eslint-disable react/display-name */
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { CSSProperties, ReactNode, forwardRef } from 'react';

export interface ListItemProps {
  data?: any;
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
}

export const ListItem = forwardRef<HTMLLIElement, ListItemProps>(
  (props, ref) => {
    return (
      <li
        ref={ref}
        {...props}
        className={classNames(props.className, 'k-item')}
      />
    );
  },
);

ListItem.defaultProps = {
  style: {},
};
